import React, { useState, useEffect } from "react";
import {
  uploadFiles,
  listFiles,
  downloadFile,
  deleteFile, uploadFilesFromDrive,
  uploadImages
} from "../services/api";

import toast from "react-hot-toast";
import { RxCross2 } from "react-icons/rx";
import { DataState } from "../context/DataProvider";
import { IoIosArrowForward } from "react-icons/io";
import { FaFileUpload } from "react-icons/fa";
import useDrivePicker from "react-google-drive-picker";
import { googleApiKey, googleClientId, google_client_id, google_api_key } from "../utils/keys";

const FileManagement = ({
  userGoogleId,
  justSavedFiles,
  setJustSavedFiles,
  setTempImages,
  setJustUploadedImages,
  task_id,
}) => {
  const { files, setFiles, fetchFiles } = DataState();
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleFileChange = async (event) => {
    const selected = Array.from(event.target.files);
    
    if (selected.length === 0) return;
    if (selected.length > 10) {
      toast.error("You can select a maximum of 10 files at a time.");
      return;
    }

    const imagesToUpload = selected.filter((file) => file.type.startsWith("image/"));
    const otherFilesToUpload = selected.filter((file) => !file.type.startsWith("image/"));
    
    // FIX: Create temporary image placeholders for instant UI feedback
    if (imagesToUpload.length > 0) {
        const newTempImages = imagesToUpload.map(file => ({
            id: Date.now() + Math.random(),
            url: URL.createObjectURL(file),
            uploading: true,
        }));
        setTempImages(newTempImages);
    }

    setLoading(true);

    try {
      if (imagesToUpload.length > 0) {
        const imageData = await uploadImages(userGoogleId, task_id, imagesToUpload);
        if (imageData.error) {
          toast.error("Failed to upload some images.");
        } else {
          setJustUploadedImages(true); // Signal ImageComponent to refresh
        }
      }

      if (otherFilesToUpload.length > 0) {
        const fileData = await uploadFiles(userGoogleId, task_id, otherFilesToUpload);
        if (fileData && !fileData.error) {
          setJustSavedFiles(true);
        } else {
          toast.error("Failed to upload some files.");
        }
      }
      
      if (selected.length > 0) {
        toast.success("Files uploaded successfully!");
      }

    } catch (error) {
      console.error("Error during file upload:", error);
      toast.error("An error occurred during upload.");
    } finally {
      setLoading(false);
      setTempImages([]); // Clear temporary images after completion
    }
  };

  const handleDownload = async (fileId) => {
    try {
      const response = await downloadFile(fileId, userGoogleId);
      if (response.error) {
        setError(response.error);
      } else {
        setError(null);
      }
    } catch (error) {
      console.error("Error downloading file:", error);
      setError("Error downloading file");
    }
  };

  const handleDelete = async (fileId) => {
    try {
      const response = await deleteFile(fileId, userGoogleId);
      if (response.error) {
        setError(response.error);
      } else {
        toast.success("File deleted successfully");
        fetchFiles();
        setError(null);
      }
    } catch (error) {
      console.error("Error deleting file:", error);
      setError("Error deleting file");
    }
  };

  const [openPicker, authResponse] = useDrivePicker();
  const handleOpenPicker = () => {
    openPicker({
      clientId: google_client_id,
      developerKey: google_api_key,
      viewId: "DOCS",
      // token: token, // pass oauth token in case you already have one
      showUploadView: true,
      showUploadFolders: true,
      supportDrives: true,
      multiselect: true,
      // customViews: customViewsArray, // custom view
      callbackFunction: async (data) => {
        if (data.action === "cancel") {
          console.log("User clicked cancel/close button");
        }
        if (data.action === "picked") {
          // Extract file IDs from the picker response
          const fileIds = data.docs.map((doc) => doc.id);
          try {
            const responseData = await uploadFilesFromDrive(userGoogleId, task_id,fileIds);
            if (responseData.error){
              console.error("File saving error:", responseData.error);
            } else {
              console.log("Files saved:",responseData);
              setJustSavedFiles(true);
            }

          } catch (e) {
            console.error("File upload failed:", e)
            toast.error("File upload failed");
          }
        }
      },
    });
  };

  return (
    <div className="px-3 py-2 bg-2 text-white rounded-2xl shadow-md shadow-zinc-700">
      <button
        onClick={() => handleOpenPicker()}
        className="flex justify-between items-center gap-2 p-2 hover:bg-zinc-700 hover:bg-opacity-30 rounded-xl transition-all duration-300"
      >
        <div className="flex items-center gap-2">
          <img
            src="https://res.cloudinary.com/dsguoq6ad/image/upload/v1726229007/mentorEducationImages/lhupskidmwtibynwa0no.png"
            className="h-5 w-5"
          />
          <span className="text-xs">Connect to Google Drive</span>
        </div>
        <IoIosArrowForward />
      </button>
      <div className="relative overflow-hidden bg-zinc-700 w-full h-[1px] mt-1 mb-1"></div>
      <div className="flex justify-between items-center gap-2 p-2 hover:bg-zinc-700 hover:bg-opacity-30 rounded-xl cursor-pointer transition-all duration-300">
        <div className="flex items-center gap-2 cursor-pointer">
          <FaFileUpload className="text-white h-5 w-5 cursor-pointer" />
          <span className="text-xs cursor-pointer">Upload from computer</span>
        </div>
        <IoIosArrowForward />
        <input
          type="file"
          multiple
          onChange={handleFileChange}
          className="bg-zinc-400 absolute w-60 opacity-0 cursor-pointer"
        />
      </div>
    </div>
  );
};

export default FileManagement;
